export default {
  title: 'Price details',
  subtotal: 'Subtotal',
  method_fee: 'Delivery fee',
  tip: 'Tip',
  service_fee: 'Online processing',
  payment_method_upcharge_fee: 'PayPal fee',
  discount: 'Discount',
  taxes: 'Taxes',
  total: 'Total',
};
